const fieldReferenceHtml = require('./fieldReference.html');

/* @ngInject */
export function fieldReferenceDirective(): ng.IDirective {
  return {
    restrict: 'E',
    scope: {
      condition: '='
    },
    templateUrl: fieldReferenceHtml
  };
}
